import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SnackbarNotification from '@peoplenet/vi-components-ui/src/Notification/SnackbarNotification';
import { dismissNotification } from './GlobalNotificationActions';

class GlobalNotification extends React.PureComponent {
  handleClose = () => {
    this.props.dismissNotification();
  };

  render() {
    const { type, message, opened } = this.props;

    return (
      <SnackbarNotification
        className="global-notification__snackbar"
        open={opened}
        onClose={this.handleClose}
        type={type}
        message={message}
      />
    );
  }
}

GlobalNotification.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'info', 'warning']),
  message: PropTypes.string,
  opened: PropTypes.bool,

  dismissNotification: PropTypes.func.isRequired,
};

const mapDispatcherToProps = {
  dismissNotification,
};

const mapStateToProps = (state) => {
  return {
    ...state.globalNotification,
  };
};

export default connect(
  mapStateToProps,
  mapDispatcherToProps,
)(GlobalNotification);
